// services/session.js

export function clearSessionAndRedirect() {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("permissions");

    // Optional: if you ever store roles or secure hashes, clear them too:
    // localStorage.removeItem("role_id");
    // localStorage.removeItem("secure_url");

    alert("Session expired. Please log in again.");
    window.location.href = "/";
  } catch (err) {
    console.error("Error clearing session:", err);
  }
}

